module.exports = __webpack_public_path__ + "img/baoming.a3a3d60b.png";